export default __webpack_public_path__ + "static/media/2142.6c2beb94.png";